<template>
    <fruit-card :fruit="fruit" />
</template>

<script>
import FruitCard from '../../Components/Fruit/FruitCard.vue'

export default {
    components: { FruitCard },
    props: ['fruit']
}
</script>

<style>

</style>